import React, { Component } from 'react';
import pryzm from "assets/img/featured/pryzm.jpg";
import jasper from "assets/img/featured/jasper-menken.jpg";
import adriank from "assets/img/featured/adriank.jpg";
import daniel from "assets/img/featured/daniel.jpg";
import kanb from "assets/img/featured/kanb.jpg";

class FeaturedCitizens extends Component {
    render() {

        let UserDisplay = (props) => {
            let { name, photo, job, facebook, twitter, linkedin, instagram, youtube, website } = props.user;
            let delay = (props.delayOffset * 0.4) + 0.1;

            return <div className="col-lg-1 col-md-2 col-sm-3 no-padding wow fadeIn" data-wow-duration="1s" data-wow-delay={`${delay}s`}>
                <div className="team-single">
                    <div className="featured-img">
                        <img src={photo} alt={name} />
                    </div>
                    <div className="team-overlay featured-overlay">
                        <h4>{name}</h4>
                        <p>{job}</p>
                        <div className="team-social">
                            {facebook && <a href={facebook} target="_blank" rel="noopener noreferrer" ><i className="fa fa-facebook" /></a>}
                            {twitter && <a href={twitter} target="_blank" rel="noopener noreferrer"><i className="fa fa-twitter" /></a>}
                            {linkedin && <a href={linkedin} rel="noopener noreferrer" target="_blank"><i className="fa fa-linkedin" /></a>}
                            {instagram && <a href={instagram} rel="noopener noreferrer" target="_blank"><i className="fa fa-instagram" /></a>}
                            {youtube && <a href={youtube} rel="noopener noreferrer" target="_blank"><i className="fa fa-youtube" /></a>}
                            {website && <a href={website} rel="noopener noreferrer" target="_blank"><i className="fas fa-globe" /></a>}
                        </div>
                    </div>
                </div> {/* END team-single*/}
            </div>
        }
        let UserShowcase = (props) => {
            let { userList } = props;

            userList = [
                {
                name: "Kanbaru",
                photo: kanb,
                job: "Built synthBot",
                website: "https://audius.co/kanbaru"
            },
             {
                name: "Jasper Menken",
                photo: jasper,
                job: "Dutch Translations",
                website: "https://www.Soundcloud.com/deepseastronaut"
            },
            {
                name: "PRYZM",
                photo: pryzm,
                job: "Various sound effects",
                website: "https://soundcloud.com/pryzmwubs"
            },
            {
                name: "Adrian K",
                photo: adriank,
                job: "Various sound effects",
                website: "http://smarturl.it/DeriveEP"
            },
            {
                name: "Daniel Fernandes",
                photo: daniel,
                job: "Various sound effects",
                website: "https://youtube.com/cryptosonix"
            }
            ];

            let showcase = [];

            for (let i = 0; i < userList.length; i++) {

                showcase.push(<UserDisplay user={userList[i]} key={i} delayOffset={i} />);
            }

            return showcase;
        }
        return (
            <section id="featured">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12 text-center">
                            <h2 className="section-title">Featured Citizens</h2>
                        </div>
                    </div>
                    <div className="row justify-content-md-center">
                        <UserShowcase />
                    </div>
                </div>
            </section>
        );
    }
}

export default FeaturedCitizens;


// WEBPACK FOOTER //
// ./src/components/synthcity/landing/FeaturedCitizens.js